import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from '@mui/material'
import { makeStyles, withStyles } from '@mui/styles'
import React, { useContext } from 'react'
import { MdExpandMore, MdMail } from 'react-icons/md'
import { DateTime } from 'luxon'
import { notificacao } from '../components/api.ts'
import { GlobalContext } from '../App'
import clsx from 'clsx'

const Accordion = withStyles({
  root: {
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    padding: 0,
    marginBottom: -1,
  },
  content: {
    margin: 0,
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
  naoLido: {},
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails)

const useStyles = makeStyles((theme) => ({
  naoLido: {
    background: theme.palette.action.focus,
  },
}))

const Notificacao = ({
  dsTitulo,
  dtEnvio,
  dsDestino,
  dtLeitura,
  idNotificacao,
}) => {
  const classes = useStyles()
  const { dispatch } = useContext(GlobalContext)

  const lerNotificacao = async () => {
    if (dtLeitura) return
    const res = await notificacao('V', idNotificacao)
    if (res.confirmacao)
      dispatch({ type: 'lerNotificacao', value: idNotificacao })
  }

  return (
    <Accordion onChange={lerNotificacao}>
      <AccordionSummary
        className={clsx({ [classes.naoLido]: !dtLeitura })}
        button
        component={ListItem}
        expandIcon={<MdExpandMore />}
      >
        <ListItemIcon
          style={{
            minWidth: 35,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <MdMail />
        </ListItemIcon>
        <ListItemText
          style={{ paddingRight: 20 }}
          primary={dsTitulo}
          secondary={DateTime.fromFormat(
            dtEnvio,
            'd/MM/y hh:mm',
          ).toRelativeCalendar()}
        />
        <ListItemSecondaryAction>
          <Typography variant="caption"></Typography>
        </ListItemSecondaryAction>
      </AccordionSummary>
      <AccordionDetails style={{ fontSize: 12 }}>{dsDestino}</AccordionDetails>
      <Divider />
    </Accordion>
  )
}

export default Notificacao
